var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.325 36.6343C2.1375 36.6343 1.1875 35.6843 1.1875 34.4968V3.08745C1.1875 1.89995 2.1375 0.949951 3.325 0.949951C4.5125 0.949951 5.4625 1.89995 5.4625 3.08745V34.4968C5.4625 35.6843 4.5125 36.6343 3.325 36.6343ZM26.8969 28.7968C26.3625 28.7968 25.8281 28.5593 25.4125 28.1437C24.5812 27.3125 24.5812 25.9468 25.4125 25.1156L29.6281 20.9H15.0813C13.8938 20.9 12.9437 19.95 12.9437 18.7625C12.9437 17.575 13.8938 16.625 15.0813 16.625H29.5094L25.3531 12.4687C24.5219 11.6375 24.5219 10.2718 25.3531 9.44058C26.1844 8.60933 27.55 8.60933 28.3813 9.44058L36.2188 17.2781C36.3969 17.4562 36.575 17.6937 36.6937 17.9906C36.8125 18.2281 36.8719 18.525 36.8719 18.7625V18.8218C36.8719 19.1187 36.8125 19.3562 36.6937 19.5937C36.575 19.8312 36.4562 20.0687 36.2188 20.3062L28.3813 28.1437C27.9656 28.5593 27.4312 28.7968 26.8969 28.7968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.8d71fb90917d97b2f41cf0ee4c3633bb.svg";
export { ForwardRef as ReactComponent };